export default class DadosCadastraisModel {
    constructor(nomeLogradouro, tipoLogradouro, complemento, numero, bairro, cep, email) {
        this.nomeLogradouro = nomeLogradouro;
        this.tipoLogradouro = tipoLogradouro;
        this.complemento = complemento;
        this.numero = numero;
        this.bairro = bairro;    
        this.cep = cep;  
        this.email = email;   
    };
}